export function isIOS(){
  // iPadOS 13+ reports as Mac, but Macs don't have multi-touch
  return (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)) && !window.MSStream;
}

export function isInAppBrowser(){
  // webviews (FB, Instagram, Line, Twitter, Google app, Android wv) — no Add to Home Screen
  return /FBAN|FBAV|Instagram|Line\/|Twitter|GSA\/|wv\)/.test(navigator.userAgent);
}

export function isIOSSafari(){
  // On iOS only Safari offers the share-sheet "Add to Home Screen" flow that the
  // install prompt instructs. Every iOS browser is WebKit, but third-party ones tag
  // the UA (Chrome=CriOS, Firefox=FxiOS, Edge=EdgiOS, Opera=OPiOS/OPT, DuckDuckGo),
  // and webviews omit the "Safari" token — exclude all of those.
  const ua = navigator.userAgent;
  return isIOS() && /Safari/.test(ua) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|DuckDuckGo|GSA\/|mercury/.test(ua);
}
